var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('Autocomplete',{attrs:{"options":_vm.optionsRewritten,"placeholder":_vm.$t('filter_parcelles_proprietaires_placeholder'),"placeholder_focus":_vm.$t('filter_parcelles_proprietaires_placeholder_focus')},on:{"update:search":_vm.getOptions,"update:choice":_vm.updateChoice}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }